import React, { useState, useEffect } from 'react';
import api from '../services/api';
import axios from 'axios'; // TODO: rimuovere, usare api
import { 
  PlusIcon, 
  TrashIcon, 
  DocumentTextIcon, 
  BuildingOfficeIcon,
  ExclamationTriangleIcon,
  ArrowDownTrayIcon,
  ArrowUpTrayIcon,
  CheckCircleIcon,
  XMarkIcon,
  ExclamationCircleIcon,
  DocumentArrowDownIcon,
  PaperClipIcon,
  UserIcon,
  PencilIcon
} from '@heroicons/react/24/outline';

const SocietaNoleggioDocumentiTemplate = () => {
  const [loading, setLoading] = useState(true);
  const [tipiCliente, setTipiCliente] = useState([]);
  const [societaNoleggio, setSocietaNoleggio] = useState([]);
  const [documentiConfig, setDocumentiConfig] = useState({});
  const [showAddDocumentoModal, setShowAddDocumentoModal] = useState(false);
  const [showEditDocumentoModal, setShowEditDocumentoModal] = useState(false);
  const [selectedTipoCliente, setSelectedTipoCliente] = useState('');
  const [selectedSocieta, setSelectedSocieta] = useState('');
  const [nuovoDocumento, setNuovoDocumento] = useState('');
  const [documentoOpzionale, setDocumentoOpzionale] = useState(false);
  const [multiTipoCliente, setMultiTipoCliente] = useState(false);
  const [selectedTipiCliente, setSelectedTipiCliente] = useState([]);
  const [templateFile, setTemplateFile] = useState(null);
  const [uploadingTemplate, setUploadingTemplate] = useState(false);
  const [editingDocument, setEditingDocument] = useState(null);
  const [notification, setNotification] = useState({ 
    show: false, 
    message: '', 
    type: 'success',
    timeout: null 
  });

  const fetchConfigurazioneDocumenti = async () => {
    setLoading(true);
    try {
      // Carica tipi cliente
      const tipiResponse = await api.get('/configurazione/tipi-cliente');
      const tipiNormalizzati = normalizeTipiCliente(tipiResponse.data);
      setTipiCliente(tipiNormalizzati);

      // Carica società di noleggio
      const societaResponse = await api.get('/noleggio/societanoleggio');
      setSocietaNoleggio(societaResponse.data.societa || societaResponse.data);

      // Carica configurazione documenti
      const documentiResponse = await api.get('/configurazione/documenti');
      setDocumentiConfig(documentiResponse.data);

    } catch (error) {
      console.error('Errore nel caricamento configurazione:', error);
      initializeDefaultData();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchConfigurazioneDocumenti();
  }, []);

  const initializeDefaultData = () => {
    const tipiDefault = [
      {
        codice: 'persona_fisica',
        nome: 'Persona Fisica',
        categoria: 'privato'
      },
      {
        codice: 'pensionati',
        nome: 'Pensionati',
        categoria: 'privato'
      },
      {
        codice: 'libero_professionista',
        nome: 'Libero Professionista',
        categoria: 'azienda'
      },
      {
        codice: 'ditta_individuale',
        nome: 'Ditta Individuale',
        categoria: 'azienda'
      },
      {
        codice: 'societa_persone',
        nome: 'Società di Persone',
        categoria: 'azienda'
      },
      {
        codice: 'societa_capitali',
        nome: 'Società di Capitali',
        categoria: 'azienda'
      },
      {
        codice: 'consorzi_onlus',
        nome: 'Consorzi/ONLUS',
        categoria: 'azienda'
      },
      {
        codice: 'societa_estere',
        nome: 'Società Estere',
        categoria: 'azienda'
      }
    ];
    
    const societaDefault = [
      { id: 1, nome: 'Arval' },
      { id: 2, nome: 'Leasys' },
      { id: 3, nome: 'Ayvens' },
      { id: 4, nome: 'Santander' },
      { id: 5, nome: 'Athlon' },
      { id: 6, nome: 'Alphabet' },
      { id: 7, nome: 'Unipol' },
      { id: 8, nome: 'Skoda' },
      { id: 9, nome: 'Volkswagen' }
    ];

    setTipiCliente(tipiDefault);
    setSocietaNoleggio(societaDefault);
    setDocumentiConfig({});
  };

  // Funzione per normalizzare i tipi cliente (retrocompatibilità)
  const normalizeTipiCliente = (tipi) => {
    return tipi.map(tipo => {
      // Se è già un oggetto con struttura nuova, lo restituisce così com'è
      if (typeof tipo === 'object' && tipo.codice && tipo.nome && tipo.categoria) {
        return tipo;
      }
      
      // Se è una stringa (formato vecchio), la converte al nuovo formato
      if (typeof tipo === 'string') {
        const map = {
          'persona_fisica': { nome: 'Persona Fisica', categoria: 'privato' },
          'pensionati': { nome: 'Pensionati', categoria: 'privato' },
          'libero_professionista': { nome: 'Libero Professionista', categoria: 'azienda' },
          'ditta_individuale': { nome: 'Ditta Individuale', categoria: 'azienda' },
          'societa_persone': { nome: 'Società di Persone', categoria: 'azienda' },
          'societa_capitali': { nome: 'Società di Capitali', categoria: 'azienda' },
          'consorzi_onlus': { nome: 'Consorzi/ONLUS', categoria: 'azienda' },
          'societa_estere': { nome: 'Società Estere', categoria: 'azienda' }
        };
        
        const mappedTipo = map[tipo];
        return {
          codice: tipo,
          nome: mappedTipo?.nome || tipo,
          categoria: mappedTipo?.categoria || 'privato'
        };
      }
      
      // Se è un oggetto ma non ha la struttura completa, prova a ripararlo
      return {
        codice: tipo.codice || tipo,
        nome: tipo.nome || tipo,
        categoria: tipo.categoria || 'privato'
      };
    });
  };

  // Funzione per ottenere il codice del tipo cliente (retrocompatibilità)
  const getTipoClienteCodice = (tipo) => {
    return typeof tipo === 'string' ? tipo : tipo.codice;
  };

  // Funzione per ottenere il nome formattato del tipo cliente
  const formatTipoCliente = (tipo) => {
    if (typeof tipo === 'string') {
      const map = {
        'persona_fisica': 'Persona Fisica',
        'pensionati': 'Pensionati',
        'libero_professionista': 'Libero Professionista',
        'ditta_individuale': 'Ditta Individuale',
        'societa_persone': 'Società di Persone',
        'societa_capitali': 'Società di Capitali',
        'consorzi_onlus': 'Consorzi/ONLUS',
        'societa_estere': 'Società Estere'
      };
      return map[tipo] || tipo;
    }
    return tipo.nome || tipo.codice;
  };

  // Funzione per ottenere la categoria del tipo cliente
  const getTipoClienteCategoria = (tipo) => {
    if (typeof tipo === 'string') {
      const categorieDefault = {
        'persona_fisica': 'privato',
        'pensionati': 'privato',
        'libero_professionista': 'azienda',
        'ditta_individuale': 'azienda',
        'societa_persone': 'azienda',
        'societa_capitali': 'azienda',
        'consorzi_onlus': 'azienda',
        'societa_estere': 'azienda'
      };
      return categorieDefault[tipo] || 'privato';
    }
    return tipo.categoria || 'privato';
  };

  // Funzione per mostrare una notifica (sistema standard dell'app)
  const showNotification = (message, type = 'success') => {
    // Clear any existing timeout
    if (notification.timeout) {
      clearTimeout(notification.timeout);
    }
    
    // Set the notification
    setNotification({
      show: true,
      message,
      type,
      timeout: setTimeout(() => {
        setNotification(prev => ({ ...prev, show: false }));
      }, 3000)
    });
  };

  const uploadTemplate = async (file, tipoCliente, societa, descrizioneDocumento) => {
    const formData = new FormData();
    formData.append('template', file);
    formData.append('tipoCliente', tipoCliente);
    formData.append('societa', societa || '');
    formData.append('descrizioneDocumento', descrizioneDocumento);

    try {
      const response = await api.post('/configurazione/documenti/template', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data.templatePath;
    } catch (error) {
      console.error('Errore nel caricamento template:', error);
      throw error;
    }
  };

  const aggiungiDocumento = async () => {
    // Validazione
    if (multiTipoCliente) {
      if (selectedTipiCliente.length === 0 || !nuovoDocumento.trim()) {
        showNotification('Seleziona almeno un tipo cliente e compila la descrizione', 'error');
        return;
      }
    } else {
      if (!selectedTipoCliente || !nuovoDocumento.trim()) {
        showNotification('Compila tutti i campi obbligatori', 'error');
        return;
      }
    }

    setUploadingTemplate(true);
    try {
      const chiave = selectedSocieta || 'base';
      const nuovaConfig = { ...documentiConfig };
      
      // Determina i tipi cliente da processare
      const tipiClienteDaProcessare = multiTipoCliente ? 
        selectedTipiCliente : 
        [getTipoClienteCodice(selectedTipoCliente)];
      
      // Crea l'oggetto documento base
      const documentoBase = {
        descrizione: nuovoDocumento.trim(),
        opzionale: documentoOpzionale,
        template: null,
        dataCreazione: new Date().toISOString()
      };

      // Se è multi-tipo, aggiungi metadata
      if (multiTipoCliente && selectedTipiCliente.length > 1) {
        documentoBase.multiTipo = true;
        documentoBase.tipiCliente = selectedTipiCliente;
      }

      // Carica template se necessario (solo per società specifiche)
      let templateData = null;
      if (templateFile && selectedSocieta) {
        try {
          const templatePath = await uploadTemplate(templateFile, 'multi', selectedSocieta, nuovoDocumento.trim());
          templateData = {
            fileName: templateFile.name,
            path: templatePath,
            size: templateFile.size,
            type: templateFile.type
          };
        } catch (error) {
          showNotification('Errore nel caricamento del template, il documento verrà salvato senza template', 'warning');
        }
      }

      // Aggiungi il documento per ogni tipo cliente selezionato
      for (const tipoClienteCodice of tipiClienteDaProcessare) {
        if (!nuovaConfig[tipoClienteCodice]) {
          nuovaConfig[tipoClienteCodice] = {};
        }
        if (!nuovaConfig[tipoClienteCodice][chiave]) {
          nuovaConfig[tipoClienteCodice][chiave] = [];
        }
        
        const documento = { ...documentoBase };
        if (templateData) {
          documento.template = templateData;
        }
        
        nuovaConfig[tipoClienteCodice][chiave].push(documento);
      }
      
      await api.put('/configurazione/documenti', nuovaConfig);
      setDocumentiConfig(nuovaConfig);
      
      chiudiModalAggiunta();
      
      const tipiCount = tipiClienteDaProcessare.length;
      const message = tipiCount > 1 ? 
        `Documento aggiunto con successo per ${tipiCount} tipi cliente` :
        templateFile && selectedSocieta ? 
          'Documento aggiunto con successo con template allegato' : 
          'Documento aggiunto con successo';
      showNotification(message, 'success');
    } catch (error) {
      console.error('Errore nell\'aggiunta del documento:', error);
      showNotification('Errore nell\'aggiunta del documento', 'error');
    } finally {
      setUploadingTemplate(false);
    }
  };

  const rimuoviDocumento = async (tipoCliente, societa, index) => {
    const documento = documentiConfig[tipoCliente]?.[societa || 'base']?.[index];
    const hasTemplate = documento?.template;
    
    const message = hasTemplate ? 
      'Sei sicuro di voler rimuovere questo documento? Il template associato verrà eliminato definitivamente.' :
      'Sei sicuro di voler rimuovere questo documento?';

    if (!window.confirm(message)) {
      return;
    }

    try {
      const nuovaConfig = { ...documentiConfig };
      const chiave = societa || 'base';
      
      if (nuovaConfig[tipoCliente] && nuovaConfig[tipoCliente][chiave]) {
        // Se il documento ha un template, eliminalo dal server
        if (hasTemplate) {
          try {
            await api.delete('/configurazione/documenti/template', {
              data: { templatePath: documento.template.path }
            });
          } catch (error) {
            console.warn('Errore nell\'eliminazione del template:', error);
          }
        }

        nuovaConfig[tipoCliente][chiave].splice(index, 1);
        
        // Se non ci sono più documenti, rimuovi la chiave
        if (nuovaConfig[tipoCliente][chiave].length === 0) {
          delete nuovaConfig[tipoCliente][chiave];
        }
        
        // Se non ci sono più configurazioni per il tipo cliente, rimuovi il tipo
        if (Object.keys(nuovaConfig[tipoCliente]).length === 0) {
          delete nuovaConfig[tipoCliente];
        }
      }
      
      await api.put('/configurazione/documenti', nuovaConfig);
      setDocumentiConfig(nuovaConfig);
      showNotification('Documento rimosso con successo', 'success');
    } catch (error) {
      console.error('Errore nella rimozione del documento:', error);
      showNotification('Errore nella rimozione del documento', 'error');
    }
  };

  const downloadTemplate = async (templatePath, fileName) => {
    try {
      const response = await api.get(`/configurazione/documenti/template/download`, {
        params: { path: templatePath },
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      showNotification('Template scaricato con successo', 'success');
    } catch (error) {
      console.error('Errore nel download del template:', error);
      showNotification('Errore nel download del template', 'error');
    }
  };

  const esportaConfigurazione = async () => {
    try {
      const dataStr = JSON.stringify(documentiConfig, null, 2);
      const dataBlob = new Blob([dataStr], { type: 'application/json' });
      const url = URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `configurazione-documenti-${new Date().toISOString().split('T')[0]}.json`;
      link.click();
      URL.revokeObjectURL(url);
      showNotification('Configurazione esportata con successo', 'success');
    } catch (error) {
      console.error('Errore nell\'esportazione:', error);
      showNotification('Errore nell\'esportazione della configurazione', 'error');
    }
  };

  const importaConfigurazione = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!window.confirm('Sei sicuro di voler importare questa configurazione? I dati attuali verranno sovrascritti.')) {
      event.target.value = '';
      return;
    }

    try {
      const text = await file.text();
      const config = JSON.parse(text);
      
      await api.put('/configurazione/documenti', config);
      setDocumentiConfig(config);
      showNotification('Configurazione importata con successo', 'success');
    } catch (error) {
      console.error('Errore nell\'importazione:', error);
      showNotification('Errore nell\'importazione della configurazione. Verifica che il file sia valido.', 'error');
    }
    
    // Reset input file
    event.target.value = '';
  };

  const processFile = (file) => {
    // Verifica il tipo di file
    const allowedTypes = [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword',
      'image/jpeg',
      'image/png'
    ];
    
    if (!allowedTypes.includes(file.type)) {
      showNotification('Tipo di file non supportato. Sono ammessi solo: PDF, Word, JPEG, PNG', 'error');
      return false;
    }
    
    // Verifica la dimensione (max 5MB)
    if (file.size > 5 * 1024 * 1024) {
      showNotification('Il file è troppo grande. Dimensione massima: 5MB', 'error');
      return false;
    }
    
    setTemplateFile(file);
    return true;
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      processFile(file);
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = 'copy';
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (files.length > 0) {
      processFile(files[0]);
    }
  };

  const renderDocumento = (documento, index, tipoCliente, societa) => {
    // Supporta sia il formato vecchio (stringa) che nuovo (oggetto)
    const isOldFormat = typeof documento === 'string';
    const descrizione = isOldFormat ? documento : documento.descrizione;
    const template = isOldFormat ? null : documento.template;
    const opzionale = isOldFormat ? false : (documento.opzionale || false);
    const isMultiTipo = !isOldFormat && documento.multiTipo;
    const tipiClienteDoc = !isOldFormat && documento.tipiCliente ? documento.tipiCliente : [];

    // Funzione per contare quanti altri tipi cliente hanno lo stesso documento
    const contaDocumentiIdentici = () => {
      if (isOldFormat || !isMultiTipo) return 0;
      
      let count = 0;
      Object.entries(documentiConfig).forEach(([tipoClienteKey, configTipo]) => {
        if (tipoClienteKey !== tipoCliente) {
          const docs = configTipo[societa] || [];
          const hasIdentical = docs.some(doc => 
            typeof doc === 'object' && 
            doc.descrizione === descrizione &&
            doc.multiTipo &&
            JSON.stringify(doc.tipiCliente?.sort()) === JSON.stringify(tipiClienteDoc.sort())
          );
          if (hasIdentical) count++;
        }
      });
      return count;
    };

    const documentiIdentici = contaDocumentiIdentici();

    return (
      <div key={index} className={`flex items-center justify-between p-3 rounded-lg border transition-colors ${
        opzionale ? 'bg-blue-50 border-blue-200' : 'bg-gray-50 border-gray-200 hover:border-gray-300'
      }`}>
        <div className="flex-1">
          <div className="flex items-center flex-wrap gap-2">
            <span className={`text-sm font-medium ${opzionale ? 'text-blue-700' : 'text-gray-700'}`}>
              {descrizione}
            </span>
            
            {opzionale && (
              <span className="px-2 py-1 bg-blue-100 text-blue-700 text-xs rounded-full font-medium">
                Opzionale
              </span>
            )}
            
            {isMultiTipo && tipiClienteDoc.length > 1 && (
              <span className="px-2 py-1 bg-purple-100 text-purple-700 text-xs rounded-full font-medium flex items-center">
                <UserIcon className="h-3 w-3 mr-1" />
                Multi-tipo ({tipiClienteDoc.length})
              </span>
            )}
            
            {documentiIdentici > 0 && (
              <span className="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full font-medium">
                +{documentiIdentici} altri tipi
              </span>
            )}
          </div>
          
          {template && (
            <div className="flex items-center mt-1 text-xs text-blue-600">
              <PaperClipIcon className="h-3 w-3 mr-1" />
              <span>Template: {template.fileName}</span>
            </div>
          )}
          
          {isMultiTipo && tipiClienteDoc.length > 0 && (
            <div className="flex items-center mt-1 text-xs text-purple-600">
              <span>Applicato a: </span>
              <span className="ml-1 font-medium">
                {tipiClienteDoc.map(codice => {
                  const tipo = tipiCliente.find(t => getTipoClienteCodice(t) === codice);
                  return tipo ? formatTipoCliente(tipo) : codice;
                }).join(', ')}
              </span>
            </div>
          )}
        </div>
        <div className="flex items-center space-x-2">
          {template && (
            <button
              onClick={() => downloadTemplate(template.path, template.fileName)}
              className="text-blue-600 hover:text-blue-800 p-1 rounded"
              title="Scarica template"
            >
              <DocumentArrowDownIcon className="h-4 w-4" />
            </button>
          )}
          <button
            onClick={() => apriModalModificaDocumento(tipoCliente, societa, index)}
            className="text-gray-600 hover:text-gray-800 p-1 rounded"
            title="Modifica documento"
          >
            <PencilIcon className="h-4 w-4" />
          </button>
          <button
            onClick={() => rimuoviDocumento(tipoCliente, societa === 'base' ? null : societa, index)}
            className="text-red-600 hover:text-red-800 p-1 rounded"
            title="Rimuovi documento"
          >
            <TrashIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    );
  };

  // Funzione per cambiare categoria di un tipo cliente
  const cambiaCategoriaTipoCliente = async (codice, nuovaCategoria) => {
    try {
      await api.put(`/configurazione/tipi-cliente/${codice}/categoria`, {
        categoria: nuovaCategoria
      });
      
      // Aggiorna lo stato locale
      const tipiAggiornati = tipiCliente.map(tipo => {
        const tipoCode = getTipoClienteCodice(tipo);
        if (tipoCode === codice) {
          return {
            ...tipo,
            categoria: nuovaCategoria
          };
        }
        return tipo;
      });
      
      setTipiCliente(tipiAggiornati);
      showNotification(`Categoria aggiornata a "${nuovaCategoria}" con successo`, 'success');
    } catch (error) {
      console.error('Errore nel cambio categoria:', error);
      showNotification('Errore nel cambio categoria', 'error');
    }
  };

  // Funzione per aprire il modal di modifica documento
  const apriModalModificaDocumento = (tipoCliente, societa, index) => {
    const documento = documentiConfig[tipoCliente]?.[societa || 'base']?.[index];
    if (!documento) return;

    // Supporta sia formato vecchio (stringa) che nuovo (oggetto)
    const isOldFormat = typeof documento === 'string';
    
    setEditingDocument({
      tipoCliente,
      societa: societa === 'base' ? '' : societa,
      index,
      documento: documento
    });
    
    setSelectedTipoCliente(tipoCliente);
    setSelectedSocieta(societa === 'base' ? '' : societa);
    setNuovoDocumento(isOldFormat ? documento : documento.descrizione);
    setDocumentoOpzionale(isOldFormat ? false : (documento.opzionale || false));
    setMultiTipoCliente(false);
    setSelectedTipiCliente([]);
    setTemplateFile(null);
    setShowEditDocumentoModal(true);
  };

  // Funzione per chiudere modal di modifica
  const chiudiModalModifica = () => {
    setShowEditDocumentoModal(false);
    setEditingDocument(null);
    setSelectedTipoCliente('');
    setSelectedSocieta('');
    setNuovoDocumento('');
    setDocumentoOpzionale(false);
    setMultiTipoCliente(false);
    setSelectedTipiCliente([]);
    setTemplateFile(null);
  };

  // Funzione per chiudere modal di aggiunta
  const chiudiModalAggiunta = () => {
    setShowAddDocumentoModal(false);
    setSelectedTipoCliente('');
    setSelectedSocieta('');
    setNuovoDocumento('');
    setDocumentoOpzionale(false);
    setMultiTipoCliente(false);
    setSelectedTipiCliente([]);
    setTemplateFile(null);
  };

  const modificaDocumento = async () => {
    if (!selectedTipoCliente || !nuovoDocumento.trim() || !editingDocument) {
      showNotification('Compila tutti i campi obbligatori', 'error');
      return;
    }

    setUploadingTemplate(true);
    try {
      const tipoClienteCodice = getTipoClienteCodice(selectedTipoCliente);
      const chiave = selectedSocieta || 'base';
      
      const nuovaConfig = { ...documentiConfig };
      
      if (!nuovaConfig[tipoClienteCodice] || !nuovaConfig[tipoClienteCodice][chiave]) {
        showNotification('Documento non trovato', 'error');
        return;
      }

      const documentoEsistente = nuovaConfig[tipoClienteCodice][chiave][editingDocument.index];
      const isOldFormat = typeof documentoEsistente === 'string';
      
      // Crea l'oggetto documento aggiornato
      const documentoAggiornato = {
        descrizione: nuovoDocumento.trim(),
        opzionale: documentoOpzionale,
        template: isOldFormat ? null : (documentoEsistente.template || null),
        dataCreazione: isOldFormat ? new Date().toISOString() : (documentoEsistente.dataCreazione || new Date().toISOString()),
        dataModifica: new Date().toISOString()
      };

      // Gestione del nuovo template se caricato
      if (templateFile && selectedSocieta) {
        try {
          // Se c'era un template precedente, eliminalo
          if (!isOldFormat && documentoEsistente.template) {
            try {
              await api.delete('/configurazione/documenti/template', {
                data: { templatePath: documentoEsistente.template.path }
              });
            } catch (error) {
              console.warn('Errore nell\'eliminazione del template precedente:', error);
            }
          }

          const templatePath = await uploadTemplate(templateFile, tipoClienteCodice, selectedSocieta, nuovoDocumento.trim());
          documentoAggiornato.template = {
            fileName: templateFile.name,
            path: templatePath,
            size: templateFile.size,
            type: templateFile.type
          };
        } catch (error) {
          showNotification('Errore nel caricamento del nuovo template', 'warning');
        }
      }
      
      nuovaConfig[tipoClienteCodice][chiave][editingDocument.index] = documentoAggiornato;
      
      await api.put('/configurazione/documenti', nuovaConfig);
      setDocumentiConfig(nuovaConfig);
      
      chiudiModalModifica();
      
      const message = templateFile && selectedSocieta ? 
        'Documento modificato con successo con nuovo template' : 
        'Documento modificato con successo';
      showNotification(message, 'success');
    } catch (error) {
      console.error('Errore nella modifica del documento:', error);
      showNotification('Errore nella modifica del documento', 'error');
    } finally {
      setUploadingTemplate(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
        <span className="ml-2 text-gray-600">Caricamento configurazione documenti...</span>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Notifiche standard dell'app */}
      {notification.show && (
        <div 
          className={`fixed top-4 right-4 z-50 shadow-lg rounded-md px-4 py-3 border-l-4 flex items-start transition-all duration-300 animate-slide-in-right max-w-md ${
            notification.type === 'success' ? 'bg-green-50 text-green-800 border-green-500' :
            notification.type === 'error' ? 'bg-red-50 text-red-800 border-red-500' :
            notification.type === 'warning' ? 'bg-yellow-50 text-yellow-800 border-yellow-500' :
            'bg-blue-50 text-blue-800 border-blue-500'
          }`}
        >
          <div className="mr-3 flex-shrink-0">
            {notification.type === 'success' && (
              <svg className="h-5 w-5 text-green-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            )}
            {notification.type === 'error' && (
              <svg className="h-5 w-5 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            )}
            {notification.type === 'warning' && (
              <svg className="h-5 w-5 text-yellow-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
              </svg>
            )}
            {notification.type === 'info' && (
              <svg className="h-5 w-5 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            )}
          </div>
          <div className="flex-1">
            <p className="font-medium">{notification.message}</p>
          </div>
          <button 
            className="ml-4 flex-shrink-0 text-gray-400 hover:text-gray-600"
            onClick={() => setNotification(prev => ({ ...prev, show: false }))}
          >
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      )}

      {/* Header */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center space-y-4 md:space-y-0">
        <div className="flex-1">
          <h2 className="text-xl font-bold text-gray-900">Gestione Documenti Template</h2>
          <p className="text-sm text-gray-600">
            Configura i documenti richiesti per tipo cliente e società di noleggio
          </p>
          
          {/* Statistiche tipi cliente */}
          <div className="flex items-center space-x-4 mt-2">
            <div className="flex items-center text-sm text-green-700">
              <UserIcon className="h-4 w-4 mr-1" />
              <span className="font-medium">
                {tipiCliente.filter(tipo => getTipoClienteCategoria(tipo) === 'privato').length} Privati
              </span>
            </div>
            <div className="flex items-center text-sm text-blue-700">
              <BuildingOfficeIcon className="h-4 w-4 mr-1" />
              <span className="font-medium">
                {tipiCliente.filter(tipo => getTipoClienteCategoria(tipo) === 'azienda').length} Aziende
              </span>
            </div>
          </div>
        </div>
        
        <div className="flex space-x-3">
          <label className="flex items-center px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 cursor-pointer">
            <ArrowUpTrayIcon className="h-4 w-4 mr-2" />
            Importa
            <input
              type="file"
              accept=".json"
              onChange={importaConfigurazione}
              className="hidden"
            />
          </label>
          
          <button
            onClick={esportaConfigurazione}
            className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            <ArrowDownTrayIcon className="h-4 w-4 mr-2" />
            Esporta
          </button>
          
          <button
            onClick={() => setShowAddDocumentoModal(true)}
            className="flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
          >
            <PlusIcon className="h-4 w-4 mr-2" />
            Aggiungi Documento
          </button>
        </div>
      </div>

      {/* Configurazione Documenti per Tipo Cliente */}
      <div className="space-y-6">
        {tipiCliente.length === 0 ? (
          <div className="text-center py-8 bg-white rounded-lg shadow border">
            <ExclamationTriangleIcon className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Nessun tipo cliente configurato</h3>
            <p className="text-gray-600">Aggiungi il primo documento per iniziare la configurazione.</p>
          </div>
        ) : (
          tipiCliente.map((tipoCliente) => {
            const codice = getTipoClienteCodice(tipoCliente);
            const categoria = getTipoClienteCategoria(tipoCliente);
            const isPrivato = categoria === 'privato';
            
            return (
              <div key={codice} className="bg-white rounded-lg shadow-sm border">
                <div className="px-6 py-4 border-b bg-gray-50">
                  <div className="flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                      <DocumentTextIcon className="h-5 w-5 mr-2 text-blue-600" />
                      {formatTipoCliente(tipoCliente)}
                    </h3>
                    <div className={`flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                      isPrivato ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800'
                    }`}>
                      {isPrivato ? (
                        <UserIcon className="h-4 w-4 mr-1" />
                      ) : (
                        <BuildingOfficeIcon className="h-4 w-4 mr-1" />
                      )}
                      <span className="mr-2">{isPrivato ? 'Privato' : 'Azienda'}</span>
                      <button
                        onClick={() => cambiaCategoriaTipoCliente(codice, isPrivato ? 'azienda' : 'privato')}
                        className="text-xs underline hover:no-underline transition-all duration-200"
                        title={`Cambia a ${isPrivato ? 'Azienda' : 'Privato'}`}
                      >
                        Cambia
                      </button>
                    </div>
                  </div>
                </div>
                
                <div className="p-6">
                  {documentiConfig[codice] ? (
                    Object.entries(documentiConfig[codice]).map(([societa, documenti]) => (
                      <div key={societa} className="mb-6 last:mb-0">
                        <h4 className="font-medium text-gray-900 mb-3 flex items-center">
                          {societa === 'base' ? (
                            <>
                              <DocumentTextIcon className="h-4 w-4 mr-2 text-gray-600" />
                              Documenti Base
                            </>
                          ) : (
                            <>
                              <BuildingOfficeIcon className="h-4 w-4 mr-2 text-blue-600" />
                              {societa} - Documenti Aggiuntivi
                            </>
                          )}
                        </h4>
                        
                        <div className="space-y-2">
                          {documenti.map((documento, index) => renderDocumento(documento, index, codice, societa))}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-8">
                      <DocumentTextIcon className="h-8 w-8 text-gray-400 mx-auto mb-2" />
                      <p className="text-gray-500 text-sm">Nessun documento configurato per questo tipo di cliente</p>
                    </div>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>

      {/* Modal Aggiungi Documento */}
      {showAddDocumentoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <DocumentTextIcon className="h-5 w-5 mr-2 text-blue-600" />
              Aggiungi Documento
            </h3>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tipo Cliente *
                </label>
                
                {/* Checkbox per modalità multi-selezione */}
                <div className="mb-3">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="multiTipoCliente"
                      checked={multiTipoCliente}
                      onChange={(e) => {
                        setMultiTipoCliente(e.target.checked);
                        if (e.target.checked) {
                          setSelectedTipoCliente('');
                          setSelectedTipiCliente([]);
                        } else {
                          setSelectedTipiCliente([]);
                        }
                      }}
                      className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    />
                    <label htmlFor="multiTipoCliente" className="ml-2 text-sm text-gray-700">
                      Applica a più tipi cliente
                    </label>
                    <span className="ml-2 text-xs text-gray-500">
                      (Il documento verrà aggiunto a tutti i tipi selezionati)
                    </span>
                  </div>
                </div>

                {multiTipoCliente ? (
                  /* Selezione multipla con checkbox */
                  <div className="space-y-2 max-h-48 overflow-y-auto border border-gray-300 rounded-lg p-3">
                    <div className="flex items-center justify-between mb-2">
                      <p className="text-sm text-gray-600">Seleziona i tipi cliente:</p>
                      <div className="flex space-x-2">
                        <button
                          type="button"
                          onClick={() => setSelectedTipiCliente(tipiCliente.map(t => getTipoClienteCodice(t)))}
                          className="text-xs text-blue-600 hover:text-blue-800 underline"
                        >
                          Seleziona tutti
                        </button>
                        <span className="text-xs text-gray-400">|</span>
                        <button
                          type="button"
                          onClick={() => setSelectedTipiCliente([])}
                          className="text-xs text-gray-600 hover:text-gray-800 underline"
                        >
                          Deseleziona tutti
                        </button>
                      </div>
                    </div>
                    {tipiCliente.map((tipo) => {
                      const codice = getTipoClienteCodice(tipo);
                      const categoria = getTipoClienteCategoria(tipo);
                      const isSelected = selectedTipiCliente.includes(codice);
                      
                      return (
                        <div key={codice} className="flex items-center">
                          <input
                            type="checkbox"
                            id={`tipo-${codice}`}
                            checked={isSelected}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setSelectedTipiCliente(prev => [...prev, codice]);
                              } else {
                                setSelectedTipiCliente(prev => prev.filter(t => t !== codice));
                              }
                            }}
                            className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                          />
                          <label htmlFor={`tipo-${codice}`} className="ml-2 text-sm text-gray-700 flex items-center">
                            {categoria === 'privato' ? (
                              <UserIcon className="h-4 w-4 mr-1 text-green-600" />
                            ) : (
                              <BuildingOfficeIcon className="h-4 w-4 mr-1 text-blue-600" />
                            )}
                            {formatTipoCliente(tipo)}
                            <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-medium ${
                              categoria === 'privato' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'
                            }`}>
                              {categoria === 'privato' ? 'Privato' : 'Azienda'}
                            </span>
                          </label>
                        </div>
                      );
                    })}
                    
                    {selectedTipiCliente.length > 0 && (
                      <div className="mt-3 p-2 bg-blue-50 rounded border border-blue-200">
                        <p className="text-sm text-blue-700">
                          <strong>{selectedTipiCliente.length}</strong> tipi cliente selezionati
                        </p>
                        <div className="flex items-center space-x-4 mt-1 text-xs text-blue-600">
                          <div className="flex items-center">
                            <UserIcon className="h-3 w-3 mr-1" />
                            <span>
                              {selectedTipiCliente.filter(codice => {
                                const tipo = tipiCliente.find(t => getTipoClienteCodice(t) === codice);
                                return getTipoClienteCategoria(tipo) === 'privato';
                              }).length} Privati
                            </span>
                          </div>
                          <div className="flex items-center">
                            <BuildingOfficeIcon className="h-3 w-3 mr-1" />
                            <span>
                              {selectedTipiCliente.filter(codice => {
                                const tipo = tipiCliente.find(t => getTipoClienteCodice(t) === codice);
                                return getTipoClienteCategoria(tipo) === 'azienda';
                              }).length} Aziende
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  /* Selezione singola con dropdown */
                  <select
                    value={selectedTipoCliente}
                    onChange={(e) => setSelectedTipoCliente(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">Seleziona tipo cliente</option>
                    {tipiCliente.map((tipo) => {
                      const codice = getTipoClienteCodice(tipo);
                      const categoria = getTipoClienteCategoria(tipo);
                      return (
                        <option key={codice} value={codice}>
                          {formatTipoCliente(tipo)} ({categoria === 'privato' ? 'Privato' : 'Azienda'})
                        </option>
                      );
                    })}
                  </select>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Società di Noleggio
                </label>
                <select
                  value={selectedSocieta}
                  onChange={(e) => {
                    setSelectedSocieta(e.target.value);
                    // Reset template file quando cambia la società
                    if (!e.target.value) {
                      setTemplateFile(null);
                    }
                  }}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Documento base (tutte le società)</option>
                  {societaNoleggio.map((societa) => (
                    <option key={societa.id || societa.nome} value={societa.nome || societa}>
                      {societa.nome || societa}
                    </option>
                  ))}
                </select>
                {!selectedSocieta && (
                  <p className="mt-1 text-xs text-gray-500">
                    I documenti base si applicano a tutte le società di noleggio
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Descrizione Documento *
                </label>
                <textarea
                  value={nuovoDocumento}
                  onChange={(e) => setNuovoDocumento(e.target.value)}
                  placeholder="Es: Documento d'identità fronte e retro a colori"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 h-20 resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              {/* Checkbox Opzionale */}
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="documentoOpzionale"
                  checked={documentoOpzionale}
                  onChange={(e) => setDocumentoOpzionale(e.target.checked)}
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label htmlFor="documentoOpzionale" className="ml-2 text-sm text-gray-700">
                  Documento opzionale
                </label>
                <span className="ml-2 text-xs text-gray-500">
                  (I documenti opzionali non sono obbligatori per completare la pratica)
                </span>
              </div>

              {/* Caricamento Template - Solo per società specifiche */}
              {selectedSocieta && (
                <div className="border-t pt-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Template Documento (opzionale)
                  </label>
                  
                  <div className="space-y-3">
                    <div className="flex items-center justify-center w-full">
                      <label 
                        className={`flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-all duration-200 ${templateFile ? 'border-green-400 bg-green-50' : ''}`}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragEnter}
                        onDrop={handleDrop}
                      >
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                          {templateFile ? (
                            <>
                              <CheckCircleIcon className="w-8 h-8 mb-2 text-green-500" />
                              <p className="text-sm text-green-700 font-medium">{templateFile.name}</p>
                              <p className="text-xs text-green-600">{(templateFile.size / 1024 / 1024).toFixed(2)} MB</p>
                            </>
                          ) : (
                            <>
                              <ArrowUpTrayIcon className="w-8 h-8 mb-2 text-gray-400" />
                              <p className="mb-2 text-sm text-gray-500">
                                <span className="font-semibold">Clicca per caricare</span> o trascina qui
                              </p>
                              <p className="text-xs text-gray-500">PDF, Word, JPEG, PNG (max 5MB)</p>
                            </>
                          )}
                        </div>
                        <input 
                          type="file" 
                          className="hidden" 
                          onChange={handleFileChange}
                          accept=".pdf,.doc,.docx,.jpeg,.jpg,.png"
                        />
                      </label>
                    </div>
                    
                    {templateFile && (
                      <div className="flex items-center justify-between p-2 bg-green-50 rounded-lg border border-green-200">
                        <div className="flex items-center">
                          <PaperClipIcon className="h-4 w-4 text-green-600 mr-2" />
                          <span className="text-sm text-green-700">Template selezionato</span>
                        </div>
                        <button
                          onClick={() => setTemplateFile(null)}
                          className="text-red-600 hover:text-red-800"
                          type="button"
                        >
                          <XMarkIcon className="h-4 w-4" />
                        </button>
                      </div>
                    )}
                    
                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                      <div className="flex">
                        <ExclamationCircleIcon className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0 mt-0.5" />
                        <div className="text-xs text-blue-700">
                          <p className="font-medium mb-1">Info Template:</p>
                          <ul className="list-disc list-inside space-y-1">
                            <li>Il template sarà disponibile per il download in questa configurazione</li>
                            <li>Può essere utilizzato come modello per la compilazione del documento</li>
                            <li>Supporta formati: PDF, Word, immagini</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex justify-end space-x-3 mt-6 pt-4 border-t">
              <button
                onClick={chiudiModalAggiunta}
                className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                disabled={uploadingTemplate}
              >
                Annulla
              </button>
              <button
                onClick={aggiungiDocumento}
                disabled={uploadingTemplate || 
                  (multiTipoCliente ? selectedTipiCliente.length === 0 : !selectedTipoCliente) || 
                  !nuovoDocumento.trim()}
                className={`px-4 py-2 text-white rounded-lg transition-colors flex items-center ${
                  uploadingTemplate || 
                  (multiTipoCliente ? selectedTipiCliente.length === 0 : !selectedTipoCliente) || 
                  !nuovoDocumento.trim()
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700'
                }`}
              >
                {uploadingTemplate ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Caricamento...
                  </>
                ) : (
                  <>
                    <PlusIcon className="h-4 w-4 mr-2" />
                    Aggiungi
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal Modifica Documento */}
      {showEditDocumentoModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center">
              <PencilIcon className="h-5 w-5 mr-2 text-blue-600" />
              Modifica Documento
            </h3>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Tipo Cliente *
                </label>
                <select
                  value={selectedTipoCliente}
                  onChange={(e) => setSelectedTipoCliente(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  disabled
                >
                  <option value="">Seleziona tipo cliente</option>
                  {tipiCliente.map((tipo) => {
                    const codice = getTipoClienteCodice(tipo);
                    const categoria = getTipoClienteCategoria(tipo);
                    return (
                      <option key={codice} value={codice}>
                        {formatTipoCliente(tipo)} ({categoria === 'privato' ? 'Privato' : 'Azienda'})
                      </option>
                    );
                  })}
                </select>
                <p className="mt-1 text-xs text-gray-500">
                  Il tipo cliente non può essere modificato
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Società di Noleggio
                </label>
                <select
                  value={selectedSocieta}
                  onChange={(e) => {
                    setSelectedSocieta(e.target.value);
                    // Reset template file quando cambia la società
                    if (!e.target.value) {
                      setTemplateFile(null);
                    }
                  }}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  disabled
                >
                  <option value="">Documento base (tutte le società)</option>
                  {societaNoleggio.map((societa) => (
                    <option key={societa.id || societa.nome} value={societa.nome || societa}>
                      {societa.nome || societa}
                    </option>
                  ))}
                </select>
                <p className="mt-1 text-xs text-gray-500">
                  La società non può essere modificata
                </p>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Descrizione Documento *
                </label>
                <textarea
                  value={nuovoDocumento}
                  onChange={(e) => setNuovoDocumento(e.target.value)}
                  placeholder="Es: Documento d'identità fronte e retro a colori"
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 h-20 resize-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              {/* Checkbox Opzionale */}
              <div className="flex items-center">
                <input
                  type="checkbox"
                  id="documentoOpzionaleEdit"
                  checked={documentoOpzionale}
                  onChange={(e) => setDocumentoOpzionale(e.target.checked)}
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <label htmlFor="documentoOpzionaleEdit" className="ml-2 text-sm text-gray-700">
                  Documento opzionale
                </label>
                <span className="ml-2 text-xs text-gray-500">
                  (I documenti opzionali non sono obbligatori per completare la pratica)
                </span>
              </div>

              {/* Caricamento Template - Solo per società specifiche */}
              {selectedSocieta && (
                <div className="border-t pt-4">
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Nuovo Template Documento (opzionale)
                  </label>
                  
                  <div className="space-y-3">
                    {/* Mostra template esistente se presente */}
                    {editingDocument && editingDocument.documento && 
                     typeof editingDocument.documento !== 'string' && 
                     editingDocument.documento.template && (
                      <div className="p-3 bg-gray-50 rounded-lg border">
                        <div className="flex items-center justify-between">
                          <div className="flex items-center">
                            <PaperClipIcon className="h-4 w-4 text-gray-600 mr-2" />
                            <span className="text-sm text-gray-700">
                              Template attuale: {editingDocument.documento.template.fileName}
                            </span>
                          </div>
                          <button
                            onClick={() => downloadTemplate(editingDocument.documento.template.path, editingDocument.documento.template.fileName)}
                            className="text-blue-600 hover:text-blue-800"
                            title="Scarica template attuale"
                          >
                            <DocumentArrowDownIcon className="h-4 w-4" />
                          </button>
                        </div>
                      </div>
                    )}
                    
                    <div className="flex items-center justify-center w-full">
                      <label 
                        className={`flex flex-col items-center justify-center w-full h-32 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 transition-all duration-200 ${templateFile ? 'border-green-400 bg-green-50' : ''}`}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragEnter}
                        onDrop={handleDrop}
                      >
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                          {templateFile ? (
                            <>
                              <CheckCircleIcon className="w-8 h-8 mb-2 text-green-500" />
                              <p className="text-sm text-green-700 font-medium">{templateFile.name}</p>
                              <p className="text-xs text-green-600">{(templateFile.size / 1024 / 1024).toFixed(2)} MB</p>
                            </>
                          ) : (
                            <>
                              <ArrowUpTrayIcon className="w-8 h-8 mb-2 text-gray-400" />
                              <p className="mb-2 text-sm text-gray-500">
                                <span className="font-semibold">Clicca per sostituire template</span> o trascina qui
                              </p>
                              <p className="text-xs text-gray-500">PDF, Word, JPEG, PNG (max 5MB)</p>
                            </>
                          )}
                        </div>
                        <input 
                          type="file" 
                          className="hidden" 
                          onChange={handleFileChange}
                          accept=".pdf,.doc,.docx,.jpeg,.jpg,.png"
                        />
                      </label>
                    </div>
                    
                    {templateFile && (
                      <div className="flex items-center justify-between p-2 bg-green-50 rounded-lg border border-green-200">
                        <div className="flex items-center">
                          <PaperClipIcon className="h-4 w-4 text-green-600 mr-2" />
                          <span className="text-sm text-green-700">Nuovo template selezionato</span>
                        </div>
                        <button
                          onClick={() => setTemplateFile(null)}
                          className="text-red-600 hover:text-red-800"
                          type="button"
                        >
                          <XMarkIcon className="h-4 w-4" />
                        </button>
                      </div>
                    )}
                    
                    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                      <div className="flex">
                        <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400 mr-2 flex-shrink-0 mt-0.5" />
                        <div className="text-xs text-yellow-700">
                          <p className="font-medium mb-1">Attenzione:</p>
                          <p>Se carichi un nuovo template, quello esistente verrà sostituito definitivamente.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="flex justify-end space-x-3 mt-6 pt-4 border-t">
              <button
                onClick={chiudiModalModifica}
                className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                disabled={uploadingTemplate}
              >
                Annulla
              </button>
              <button
                onClick={modificaDocumento}
                disabled={uploadingTemplate || !selectedTipoCliente || !nuovoDocumento.trim()}
                className={`px-4 py-2 text-white rounded-lg transition-colors flex items-center ${
                  uploadingTemplate || !selectedTipoCliente || !nuovoDocumento.trim()
                    ? 'bg-gray-400 cursor-not-allowed'
                    : 'bg-blue-600 hover:bg-blue-700'
                }`}
              >
                {uploadingTemplate ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                    Salvando...
                  </>
                ) : (
                  <>
                    <PencilIcon className="h-4 w-4 mr-2" />
                    Salva Modifiche
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SocietaNoleggioDocumentiTemplate; 